import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { Vote, Send, Lock, ChevronDown, ChevronUp } from "lucide-react";

const KIND = {
  president: { title: "Eleição do Presidente do Clube", confirm: "como Presidente do Clube" },
  coopetidor: { title: "Votação para a vaga de coopetidor", confirm: "como coopetidor (Promover)" },
};

export function ElectionPanel({ club, kind = "president" }) {
  const k = KIND[kind];
  const [d, setD] = useState(null);
  const [preview, setPreview] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/elections/president?club=${encodeURIComponent(club)}&kind=${kind}`).then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, [club, kind]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const el = d.election;
  const isOpen = el?.status === "open";

  const start = async () => {
    if (!window.confirm(`Enviar o email de votação (${k.title}) aos ${d.with_email} coopetidores dos ${club}?`)) return;
    setBusy(true);
    try { const r = await api.post("/elections/president", { club, kind }); toast.success(`${r.data.sent} emails enviados`); load(); }
    catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const close = async () => {
    if (!window.confirm("Fechar a votação? Depois já ninguém pode votar.")) return;
    try { await api.post(`/elections/president/${el.id}/close`); load(); } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="kw-card p-5 space-y-3" data-testid={`election-panel-${kind}`}>
      <div className="flex flex-wrap items-center gap-3">
        <Vote className="w-5 h-5 text-[#E50000]" />
        <span className="font-display font-black uppercase flex-1">{k.title}</span>
        <span className="text-[10px] uppercase tracking-widest text-[#737373]" data-testid="election-eligible">
          {d.eligible} Observadores elegíveis · votam {d.voters} coopetidores{d.missing_email.length ? ` · ${d.missing_email.length} sem email` : ""}
        </span>
      </div>
      {el && (
        <div className="space-y-1" data-testid="election-results">
          <div className="text-xs text-[#A3A3A3]">
            Votação {isOpen ? "aberta" : "fechada"} · {el.voted} de {el.voters} já votaram
          </div>
          {el.ranking.length === 0 ? <div className="text-xs text-[#555]">Ainda sem votos.</div> : el.ranking.map((r, i) => (
            <div key={r.player_id} className="flex items-center gap-2 text-sm">
              <span className="w-5 text-[#737373]">{i + 1}.</span>
              <span className={`flex-1 ${i === 0 ? "font-bold text-white" : ""}`}>{r.name}</span>
              <span className="font-display font-black">{r.votes}</span>
            </div>
          ))}
          {!isOpen && el.ranking[0] && (
            <div className="text-[11px] text-[#EAB308] pt-1">Confirma {el.ranking[0].name} {k.confirm} no Plantel.</div>
          )}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {!isOpen && (
          <>
            <button onClick={() => setPreview(!preview)} className="kw-btn-secondary !py-1.5 text-[10px] inline-flex items-center gap-1"
              data-testid={`election-preview-toggle-${kind}`}>{preview ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />} Ver email</button>
            <button onClick={start} disabled={busy || !d.with_email} className="kw-btn-primary !py-1.5 text-[10px] inline-flex items-center gap-1"
              data-testid={`election-start-${kind}`}><Send className="w-3 h-3" /> {el ? "Nova votação" : "Enviar votação"} ({d.with_email})</button>
          </>
        )}
        {isOpen && (
          <button onClick={close} className="kw-btn-secondary !py-1.5 text-[10px] inline-flex items-center gap-1" data-testid={`election-close-${kind}`}>
            <Lock className="w-3 h-3" /> Fechar votação
          </button>
        )}
      </div>
      {preview && !isOpen && (
        <div className="bg-white text-black p-4 text-sm" data-testid="election-preview">
          <div className="text-xs text-[#555] mb-2"><b>Assunto:</b> {d.preview.subject}</div>
          <div dangerouslySetInnerHTML={{ __html: d.preview.html }} />
        </div>
      )}
    </div>
  );
}
